import type { BM25Options } from './types';

export const DEFAULT_OPTIONS: Required<BM25Options> = {
  k1: 1.2,
  b: 0.75,
  minLength: 2,
  stopWords: new Set([
    'a',
    'an',
    'and',
    'are',
    'as',
    'at',
    'be',
    'by',
    'for',
    'from',
    'has',
    'he',
    'in',
    'is',
    'it',
    'its',
    'of',
    'on',
    'that',
    'the',
    'to',
    'was',
    'were',
    'will',
    'with',
  ]),
  stemming: false,
  stemWords: (word: string) => word,
};
